import React from 'react';

const STATUS_LABELS = {
    0: { label: 'Nuovo', color: 'success', icon: 'fa-calendar' },
    1: { label: 'In Attesa', color: 'secondary', icon: 'fa-clock' },
    2: { label: 'Confermato', color: 'info', icon: 'fa-calendar-check' },
    3: { label: 'In Corso', color: 'warning', icon: 'fa-play-circle' },
    4: { label: 'Votazioni Aperte', color: 'primary', icon: 'fa-vote-yea' },
    5: { label: 'Terminato', color: 'dark', icon: 'fa-flag-checkered' },
};

const PastEvents = ({ participations, onRevealMatches }) => {
    if (!participations || participations.length === 0) return null;

    // Show all participations that have an associated Event
    const past = participations.filter(p => p.Event && p.Event.id);

    if (past.length === 0) return null;

    return (
        <div className="card glass-premium border-0 p-4 p-md-5 mb-4 fade-in-up shadow-lg" style={{ borderRadius: '45px' }}>
            <h2 className="fw-900 text-dark mb-4" style={{ fontSize: '1.5rem' }}>
                <i className="fas fa-history me-2 text-pink-600"></i> I Tuoi Eventi
            </h2>
            <div className="d-flex flex-column gap-3">
                {past.map((p, idx) => {
                    const ev = p.Event;
                    if (!ev) return null;
                    const status = STATUS_LABELS[ev.status] || STATUS_LABELS[5];
                    const isTerminated = ev.status >= 5;
                    const matchSent = p.MatchEmailSent;

                    return (
                        <div key={idx} className="card border-0 rounded-5 p-4 shadow-sm" style={{ background: 'rgba(255,255,255,0.85)', border: '1px solid rgba(219,39,119,0.08)' }}>
                            <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
                                <div className="flex-grow-1">
                                    <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                                        <span className={`badge bg-${status.color} rounded-pill px-3 py-2 small fw-700`}>
                                            <i className={`fas ${status.icon} me-1`}></i> {status.label}
                                        </span>
                                        {matchSent && (
                                            <span className="badge bg-success rounded-pill px-3 py-2 small fw-700">
                                                <i className="fas fa-envelope me-1"></i> Match Inviati
                                            </span>
                                        )}
                                    </div>
                                    <h4 className="fw-900 text-dark mb-1">{ev.name}</h4>
                                    <div className="text-muted fw-600 small">
                                        <i className="fas fa-calendar-day me-2"></i>
                                        {new Date(ev.date).toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                                        {ev.city?.name && (
                                            <span className="ms-3">
                                                <i className="fas fa-map-marker-alt me-1"></i> {ev.city.name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Match result or pending notice */}
                            <div className="mt-3 pt-3 border-top border-light">
                                {matchSent ? (
                                    <div className="d-flex align-items-center gap-3">
                                        <button
                                            onClick={() => onRevealMatches(p)}
                                            className="btn btn-pink-gradient rounded-pill px-4 py-2 fw-700 small shadow-sm hover-scale"
                                        >
                                            <i className="fas fa-magic me-2"></i>
                                            Scopri ora i tuoi match
                                        </button>
                                    </div>
                                ) : isTerminated ? (
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="bg-warning bg-opacity-10 text-warning rounded-4 px-3 py-2 fw-700 small d-flex align-items-center gap-2" style={{ color: '#d97706' }}>
                                            <i className="fas fa-hourglass-half"></i>
                                            I tuoi match arriveranno presto via email — resta sintonizzato!
                                        </div>
                                    </div>
                                ) : (
                                    <div className="text-muted small fw-600">
                                        <i className="fas fa-clock me-2 text-pink-600"></i>
                                        In attesa dei risultati — le votazioni determineranno i match.
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PastEvents;
